import { useQuery } from '@tanstack/react-query';
import { supabase } from '../services/supabase';

export interface VolunteerRequest {
  id: string;
  name?: string;
  phone?: string;
  created_at?: string;
  opportunity_id?: string;
  volunteer_opportunities?: {
    title?: string;
  } | null;
}

export const useVolunteerRequests = () => {
  return useQuery<VolunteerRequest[]>({
    queryKey: ['volunteerRequests'],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('volunteer_requests')
        .select('id, name, phone, created_at, opportunity_id, volunteer_opportunities(title)')
        .order('created_at', { ascending: false })
        .limit(500);
      if (error) throw error;
      return (data as VolunteerRequest[]) ?? [];
    },
    staleTime: 60_000,
  });
};
